import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from 'src/app/core/constants';
@Injectable({
  providedIn: 'root'
})
export class StreamingService {

  constructor() { }

  getStreamingData(): Observable<any> {
    return new Observable(observer => {
      const eventSource = new EventSource(API_ENDPOINTS.STREAMAPI);
      eventSource.onmessage = event => {
        observer.next(JSON.parse(event.data));
      };

      eventSource.onerror = error => {
        observer.error(error);
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };
    });
  }
}
